'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { allCourses } from '@/lib/courses-data';
import { Brain, Gamepad2, Users, ArrowRight, Home, ChevronRight } from 'lucide-react';

export default function ActionsPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      {/* 面包屑 */}
      <header className="border-b border-white/5 bg-[#0a0a0f]/80 backdrop-blur-sm">
        <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6">
          <div className="flex items-center gap-2 text-sm">
            <Link href="/" className="flex items-center gap-1 text-gray-400 hover:text-white transition-colors">
              <Home className="h-4 w-4" />
              <span>首页</span>
            </Link>
            <ChevronRight className="h-4 w-4 text-gray-600" />
            <span className="font-medium text-emerald-400">行动</span>
          </div>
        </div>
      </header>

      {/* 标题 */}
      <main className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="mb-12">
          <div className="inline-flex items-center gap-3 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 mb-6">
            <Brain className="h-5 w-5 text-emerald-400" />
            <span className="text-lg font-medium text-emerald-400">行动工具</span>
          </div>
          <h1 className="text-4xl font-bold text-white mb-4">文章配套行动工具</h1>
          <p className="text-xl text-gray-400">每篇文章配一套：认知测评 + 游戏化行动手册</p>
        </div>

        {/* 工具列表 */}
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {allCourses.map((course) => (
            <Link key={course.id} href={`/courses/${course.id}`}>
              <div className="group relative rounded-2xl border border-white/[0.06] bg-white/[0.03] backdrop-blur-sm p-5 transition-all duration-300 hover:border-emerald-500/20 hover:bg-white/[0.06] hover:shadow-[0_0_30px_-5px_rgba(16,185,129,0.08)]">
                <div className="flex items-start gap-3 mb-4">
                  <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-purple-600/20 to-emerald-600/20 border border-purple-500/20 flex items-center justify-center flex-shrink-0 group-hover:border-purple-500/40 transition-all">
                    <Brain className="h-6 w-6 text-purple-400" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-[15px] font-medium text-white/90 leading-relaxed group-hover:text-emerald-300 transition-colors line-clamp-2">
                      {course.title}
                    </h3>
                  </div>
                </div>

                <p className="text-sm text-white/40 leading-relaxed line-clamp-2 mb-4">
                  {course.summary}
                </p>

                <div className="flex items-center gap-4 text-xs text-white/25 mb-3">
                  <span className="inline-flex items-center gap-1 text-purple-400/60">
                    <Brain className="w-3 h-3" />
                    认知测评
                  </span>
                  <span className="inline-flex items-center gap-1 text-emerald-400/60">
                    <Gamepad2 className="w-3 h-3" />
                    行动手册
                  </span>
                </div>

                {course.tags && course.tags.length > 0 && (
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {course.tags.slice(0, 3).map((tag) => (
                      <span key={tag} className="px-2 py-0.5 text-[11px] rounded-full bg-emerald-500/10 text-emerald-400/60">
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>

        {/* 入群引导 */}
        <div className="mt-16 rounded-2xl bg-gradient-to-br from-emerald-500/10 to-cyan-500/10 border border-emerald-500/20 p-8 text-center">
          <h2 className="text-2xl font-bold text-white mb-3">想要更多行动工具？</h2>
          <p className="text-gray-400 mb-6">加入学员群，获取完整工具库和讨论机会</p>
          <div className="inline-block bg-white/5 rounded-xl p-3 border border-white/10">
            <img src="/wechat-qr.jpg" alt="扫码入群" className="w-32 h-32 rounded-lg mx-auto" />
          </div>
          <p className="text-sm text-gray-500 mt-3">扫描二维码 · 加入算法组织实验室</p>
        </div>
      </main>
    </div>
  );
}
